import React from "react";
import { Paper, Typography, Stack, Chip, Box } from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { BRAND_COLORS, brandRgba } from "../../utils/brandAssets";

const QueryPresetBrowseCard = ({ totalCount, onClick }) => (
  <Paper
    component="button"
    type="button"
    onClick={onClick}
    aria-label={`Browse ${totalCount} quick queries`}
    sx={{
      p: 2,
      width: "100%",
      height: "100%",
      textAlign: "left",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      font: "inherit",
      color: "inherit",
      position: "relative",
      overflow: "hidden",
      border: "1px dashed",
      borderColor: "primary.main",
      bgcolor: brandRgba(BRAND_COLORS.cyan, 0.06),
      transition: "transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease",
      "&:hover": {
        transform: "translateY(-2px)",
        bgcolor: brandRgba(BRAND_COLORS.cyan, 0.12),
        boxShadow: `0 10px 28px ${brandRgba(BRAND_COLORS.cyan, 0.18)}`,
      },
      "&:hover .browse-arrow": {
        transform: "translateX(4px)",
      },
    }}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ flex: 1 }}>
      <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
          <GridViewIcon color="primary" fontSize="small" />
          <Chip
            label={`${totalCount} queries`}
            size="small"
            color="primary"
            sx={{ fontWeight: 700 }}
          />
        </Stack>
        <Typography variant="subtitle2" fontWeight={800} sx={{ mb: 0.5 }}>
          Browse query library
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block">
          Milestones, power, contact, seasons, teams, and more — tap to explore.
        </Typography>
      </Box>
      <ChevronRightIcon
        className="browse-arrow"
        sx={{
          color: "primary.main",
          transition: "transform 0.15s ease",
        }}
      />
    </Stack>
  </Paper>
);

export default QueryPresetBrowseCard;
